import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Patient } from '@pixacare/domain';
import { patientsActions } from '@shared/store/patients/patients.actions';
import { Observable, tap } from 'rxjs';
import { PatientNamePipe } from 'src/app/modules/patient/patient-name.pipe';
import { DialogService } from 'src/app/services/dialog.service';

@Injectable({
  providedIn: 'root',
})
export class PatientMergeService {
  private readonly store = inject(Store);
  private readonly dialogService = inject(DialogService);
  private readonly patientNamePipe = inject(PatientNamePipe);
  private readonly translocoService = inject(TranslocoService);

  mergePatient(
    fromPatient: Patient,
    toPatient: Patient,
    {
      additionalMessage,
    }: {
      additionalMessage?: string;
    } = {},
  ): Observable<boolean> {
    const content = this.translocoService.translate(
      'Les séquences de {{from}} seront associées à {{to}}. Le patient {{from}} sera ensuite supprimé.',
      {
        from: this.patientNamePipe.transform(fromPatient),
        to: this.patientNamePipe.transform(toPatient),
      },
    );

    return this.dialogService
      .openConfirm(this.translocoService.translate('Êtes-vous sûr de vouloir fusionner ces patients ?'), {
        content: additionalMessage
          ? `
          
          ${additionalMessage}
          
          ${content} 
          
        `
          : content,
        yes: this.translocoService.translate('Fusionner'),
        no: this.translocoService.translate('Annuler'),
      })
      .pipe(
        tap((confirmed) => {
          if (confirmed) {
            this.store.dispatch(
              patientsActions.mergePatients({
                clientCode: fromPatient.clientCode,
                patientId: fromPatient.id,
                targetPatientId: toPatient.id,
              }),
            );
          }
        }),
      );
  }
}
